{
  "app": {
    "name": "Villopia",
    "title": "Villopia — construis ta ville, partage-la, elle grandit",
    "tagline": "Construis ta ville. Partage-la. Elle grandit toute seule.",
    "seoTitle": "Villopia — le city builder idle qui tourne sans toi",
    "beta": "bêta"
  },
  "boot": {
    "loading": "Chargement de la ville…",
    "loadingAssets": "Préparation du terrain…",
    "stage": "Phase 0 — fondations",
    "error": "Le jeu n'a pas pu démarrer.",
    "errorHint": "Recharge la page. Si le problème persiste, vide le cache du navigateur."
  },
  "hud": {
    "grid": "Grille {cols} × {rows}",
    "perf": "{fps} fps · zoom ×{zoom} · qualité {quality}",
    "expand": "Agrandir la grille",
    "shrink": "Réduire la grille",
    "recenter": "Recentrer la vue",
    "visitorsToday": "visiteurs reçus au total",
    "goalBuildings": "Débloquer tous les bâtiments",
    "leagueNext": "plus que {value}",
    "leagueMax": "division maximale",
    "online": "en ligne",
    "onlineTitle": "Joueurs connectés en ce moment"
  },
  "common": {
    "close": "Fermer",
    "cancel": "Annuler",
    "saveFailed": "Sauvegarde impossible sur cet appareil",
    "saveFailedHint": "Stockage plein ou navigation privée — ta progression risque d’être perdue."
  },
  "update": {
    "title": "Nouvelle version disponible",
    "text": "Recharge pour en profiter — ta ville est déjà sauvegardée.",
    "action": "Rafraîchir"
  },
  "install": {
    "title": "Installer Villopia",
    "action": "Installer",
    "ios": "Appuie sur Partager, puis « Sur l'écran d'accueil ».",
    "why": "Le jeu s'ouvre en plein écran et se lance d'un seul geste.",
    "done": "Déjà installée sur cet appareil."
  },
  "settings": {
    "title": "Réglages",
    "language": {
      "label": "Langue",
      "fr": "Français",
      "en": "English"
    },
    "sound": {
      "effects": "Volume des effets"
    },
    "credits": {
      "label": "Crédits",
      "open": "Voir les crédits",
      "title": "Crédits"
    },
    "reset": {
      "label": "Recommencer",
      "open": "Effacer ma ville",
      "title": "Tout effacer ?",
      "text": "Ta ville, tes pièces, tes gemmes et ta progression seront perdues pour de bon. Ton adresse publique reste la même.",
      "confirm": "Effacer"
    },
    "legal": "Mentions légales, confidentialité et conditions de vente",
    "account": {
      "label": "Compte"
    },
    "preferences": {
      "label": "Préférences"
    },
    "about": {
      "label": "À propos"
    },
    "publisher": "Jeu édité par"
  },
  "nav": {
    "label": "Navigation",
    "build": "Construire",
    "city": "Ville",
    "social": "Social",
    "progress": "Progression",
    "games": "Mes jeux",
    "empty": {
      "build": {
        "title": "Ce que tu peux bâtir",
        "text": "Choisis un bâtiment, pose-le, et regarde ta ville s'étendre."
      },
      "city": {
        "title": "Ta ville, en grand",
        "text": "Ici tu choisiras son thème, ses monuments et les terrains que tu veux conquérir."
      },
      "social": {
        "title": "Qui passe chez toi",
        "text": "Ici tu verras qui visite ta ville, les boosts qu’ils t’apportent et les mots qu’ils te laissent."
      },
      "progress": {
        "title": "Ton ascension",
        "text": "Tes ligues, tes jalons et ton prestige — tout ce que tu as accompli, réuni ici."
      },
      "games": {
        "title": "Mes autres jeux",
        "text": "Les autres mondes du créateur de Villopia t'attendent ici."
      }
    }
  },
  "shop": {
    "hint": "Glissez la poignée",
    "owned": "{count} possédés",
    "production": "+{value}/s",
    "cancel": "Annuler",
    "auto": "Placement auto",
    "quantityMax": "×MAX",
    "quantityLabel": "Quantité à poser",
    "autoFor": "Poser ×{count} · {value}",
    "topUpDone": "Solde complété !",
    "topUpDoneText": "+{coins} pièces pour {gems} 💎",
    "topUpRefused": {
      "too-few-gems": "Il te manque des gemmes pour compléter",
      "daily-cap": "Tu as utilisé tes avances du jour — reviens demain",
      "no-production": "Ta ville ne produit rien : pose d'abord un bâtiment",
      "nothing-missing": "Tu as déjà de quoi l'acheter",
      "invalid": "Impossible pour l'instant"
    },
    "getGems": "Obtenir des gemmes",
    "topUp": "Compléter · {value} 💎",
    "topUpUnavailable": "Pose d'abord un bâtiment",
    "readyInOrGems": "Prêt dans {value} · ou {gems} 💎",
    "readyIn": "Prêt dans {value}",
    "placedMany": "{count} bâtiments posés",
    "groupAvailable": "À construire",
    "groupLocked": "À débloquer",
    "unlockProgress": "{owned}/{need} pour débloquer",
    "unlocked": "Nouveau bâtiment débloqué !",
    "unlockedText": "{value} t'attend dans la boutique.",
    "groupDecor": "Décorer ta ville",
    "decorProduction": "Pour le plaisir des yeux",
    "decorPlaced": "Décoration posée !",
    "groupBag": "Ton sac à dos",
    "bagProduction": "À poser où tu veux",
    "tabBuildings": "Bâtiments",
    "tabDecor": "Déco",
    "groupLandmark": "Points de repère — un seul de chaque par ère",
    "tabLandmarks": "Repères",
    "landmarkOwned": "Posé dans ta ville",
    "landmarkMissing": "Il te manque {value} 💎",
    "placeLandmark": "Poser · {value} 💎",
    "landmarkUnique": "Unique — un seul par ère",
    "lockedTitle": "Pas encore débloqué",
    "lockedHint": "Pose {need} × {previous} pour débloquer {value} — tu en as {owned}.",
    "shortOnGems": "Il te manque {value} 💎",
    "shortOnGemsHint": "Pour poser {value} dans ta ville."
  },
  "buildings": {
    "house": "Maison",
    "cottage": "Chaumière",
    "streetStand": "Échoppe",
    "grocery": "Épicerie",
    "fishShop": "Poissonnerie",
    "restaurant": "Restaurant",
    "doctor": "Cabinet médical",
    "cinema": "Cinéma",
    "school": "École",
    "workplace": "Bureaux",
    "waterTower": "Château d'eau",
    "playground": "Aire de jeux",
    "poolClub": "Club piscine",
    "helipad": "Héliport"
  },
  "milestones": {
    "firstBuilding": "Premier bâtiment : {value}",
    "land": "Extension de terrain n° {value}",
    "visitors": "{value} visiteurs reçus",
    "production": "{value} pièces produites",
    "firstPrestige": "Première nouvelle ère",
    "roads": "{value} cases de rue",
    "decor": "{value} décorations posées",
    "eras": "{value} ères franchies",
    "reward": "+{count} gemmes"
  },
  "units": {
    "perSecond": "{value}/s"
  },
  "duration": {
    "days": "{count} j",
    "hours": "{count} h",
    "minutes": "{count} min",
    "seconds": "{count} s"
  },
  "leagues": {
    "wood": "Bois",
    "stone": "Pierre",
    "bronze": "Bronze",
    "silver": "Argent",
    "gold": "Or",
    "diamond": "Diamant",
    "legend": "Légende"
  },
  "city": {
    "gridSize": "Terrain",
    "tabSummary": "Résumé",
    "tabLand": "Terrain",
    "tabView": "Vue",
    "expansions": "Extensions",
    "buyLand": "Agrandir le terrain",
    "landCost": "{value} pièces",
    "cleanRoads": "Nettoyer les rues",
    "cleanRoadsFor": "Nettoyer les rues · {count} cases",
    "cleanedRoads": "Rues nettoyées !",
    "cleanedRoadsText": "{count} cases rendues à la construction.",
    "landMaxed": "Terrain au maximum",
    "landTitle": "Terrain",
    "viewTitle": "Cadrage",
    "zoomIn": "Zoomer",
    "zoomOut": "Dézoomer",
    "recenter": "Recentrer la vue",
    "collapse": "Replier le panneau",
    "expand": "Déplier le panneau",
    "landBought": "Terrain agrandi !",
    "defaultName": "Ma ville",
    "renameLabel": "Nom de ta ville",
    "rename": "Renommer",
    "renameSave": "Enregistrer",
    "statsTitle": "Ta ville en chiffres",
    "statBuildings": "Bâtiments",
    "statRoads": "Rues",
    "statProduction": "Production",
    "statVisitors": "Visiteurs reçus",
    "statEra": "Ère",
    "eraValue": "Ère {value} · ×{multiplier}",
    "sealed": {
      "weather": {
        "title": "Météo réelle",
        "text": "Bientôt : le temps qu'il fait chez toi tombera sur ta ville."
      },
      "capsule": {
        "title": "Capsule temporelle",
        "text": "Bientôt : un mot scellé pour 365 jours, à rouvrir dans un an."
      }
    },
    "renamed": "Ta ville a un nouveau nom",
    "renameRewarded": "Ville nommée ! +{value} 💎 — et te voilà éligible au classement",
    "renameNudge": "Nomme ta ville pour entrer au classement",
    "renameNudgeText": "Cinq secondes, et {value} gemmes en prime. Les villes sans nom n’y figurent pas.",
    "renameFailed": "Le renommage n'a pas abouti"
  },
  "building": {
    "upgrade": "Améliorer",
    "upgradeCost": "Améliorer · {value}",
    "maxTier": "Palier maximal",
    "maxLevel": "Niveau max",
    "maxLevelFor": "Niveau max · {value} 💎",
    "maxedOut": "Bâtiment au maximum !",
    "maxedOutText": "{count} palier(s) d'un coup — {gems} 💎",
    "rotate": "Pivoter",
    "move": "Déplacer",
    "sell": "Vendre",
    "sellFor": "Vendre · +{value}",
    "moveHint": "Touche une case libre pour reposer le bâtiment.",
    "sold": "Bâtiment vendu",
    "upgraded": "Bâtiment amélioré !",
    "tierGain": "Palier {value} sur 3 · +{gain}/s en améliorant",
    "tierMax": "Palier {value} sur 3 · maximum atteint",
    "sellConfirm": "Vendre ce bâtiment ?",
    "sellConfirmText": "Tu récupères {value} pièces, soit la moitié de son prix. Il ne revient pas.",
    "remove": "Retirer",
    "income": "Rapporte {value} pièces/s",
    "incomeShare": "Ajoute {value} pièces/s à ta ville",
    "incomeGrows": "Grandit avec ta ville"
  },
  "placement": {
    "tooExpensive": "Pas assez de pièces",
    "tooExpensiveHint": "Il t’en manque {value}.",
    "occupied": "Case occupée",
    "occupiedHint": "Vise une case libre, en dehors des rues.",
    "noSpace": "Plus de place sur l’île",
    "noSpaceHint": "Agrandis ton terrain depuis l’onglet Ville.",
    "cancelled": "Placement annulé",
    "decorHint": "Touche la case où la poser",
    "decorStored": "Rangée dans ton sac à dos",
    "noAccess": "Aucune rue ne peut y aller",
    "noAccessHint": "Cet endroit couperait la ville du reste de l’île.",
    "roadTitle": "Retirer cette rue ?",
    "roadRemove": "Retirer",
    "roadRemoved": "Rue retirée",
    "roadServes": "Cette rue dessert un bâtiment",
    "roadServesHint": "Le retirer laisserait un bâtiment sans accès.",
    "roadSplits": "Cette rue relie deux quartiers",
    "roadSplitsHint": "La retirer couperait le réseau en deux.",
    "alreadyOwned": "Tu l'as déjà",
    "alreadyOwnedHint": "Un seul de chaque point de repère par ère."
  },
  "store": {
    "title": "Boutique",
    "bonus": "+{value} offertes",
    "treasure": "Ton trésor",
    "treasureHint": "Gagnées par tes jalons, tes quêtes et tes visiteurs",
    "balanceShort": "{value} gemmes",
    "popular": "POPULAIRE",
    "tabSpend": "Dépenser",
    "tabBuy": "Obtenir des gemmes",
    "soon": "Paiement sécurisé par Stripe. Tes gemmes arrivent dès le paiement validé.",
    "soonTitle": "Pas encore ouvert",
    "failed": "Le paiement n'a pas pu démarrer",
    "paid": "Merci pour ton achat !",
    "paidText": "+{value} gemmes créditées",
    "restored": "Tes gemmes sont revenues",
    "restoredText": "+{value} gemmes restaurées depuis tes achats",
    "canceled": "Paiement annulé — rien n'a été débité",
    "fairness": "Les gemmes font gagner du temps, jamais un avantage : tout ce qui est ici s’obtient aussi en jouant.",
    "termsBefore": "En achetant, tu acceptes les ",
    "termsLink": "conditions de vente",
    "termsAfter": " et tu demandes la livraison immédiate de tes gemmes, ce qui met fin à ton droit de rétractation."
  },
  "progress": {
    "tabQuests": "Quêtes",
    "tabMilestones": "Jalons",
    "tabRanking": "Classement",
    "tabEras": "Ères"
  },
  "quests": {
    "daily": "Objectifs du jour",
    "claim": "Encaisser",
    "claimed": "Encaissé",
    "streak": "{value} jours d’affilée",
    "streakReady": "{value} gemmes t’attendent",
    "streakDone": "Reviens demain pour la suite",
    "build": "Pose {value} bâtiments",
    "earn": "Gagne {value} pièces",
    "upgrade": "Améliore {value} bâtiments",
    "land": "Agrandis ton terrain {value} fois",
    "visitors": "Reçois {value} visiteurs",
    "claimFor": "Encaisser · +{value} 💎",
    "weekly": "Objectifs de la semaine",
    "renewsIn": "renouvelé dans {value}"
  },
  "changelog": {
    "v1_15_0": {
      "i0": "Rien ne change dans le jeu : le compteur envoyé à Ludopia est corrigé"
    },
    "v1_14_0": {
      "i0": "Rien ne change dans le jeu : Villopia publie sa fréquentation à Ludopia"
    },
    "v1_13_0": {
      "i0": "Un compte Ludopia dans les réglages : pseudo, avatar et Ludos partagés"
    },
    "v1_12_0": {
      "i0": "Villopia se prépare à rejoindre la plateforme Ludopia"
    },
    "v1_11_0": {
      "i0": "Ta page publique montre qui regarde ta ville en direct"
    },
    "v1_10_0": {
      "i0": "Le classement te dit aussi devant combien de villes tu es"
    },
    "v1_9_0": {
      "i0": "Ta ville affiche son rang mondial sur sa page publique"
    },
    "v1_8_0": {
      "i0": "Tes bâtiments frémissent quand ils rapportent une pièce"
    },
    "v1_7_0": {
      "i0": "Le classement compte désormais les pièces produites au total, pas la production par seconde"
    },
    "v1_6_0": {
      "i0": "+10 💎 par réseau découvert — Discord, YouTube, TikTok"
    },
    "v1_5_0": {
      "i0": "Nomme ta ville : +25 💎, et tu entres au classement",
      "i1": "Les villes encore appelées « Ma ville » n’y figurent plus"
    },
    "v1_4_0": {
      "i0": "Rien ne change dans le jeu : le compte n’est créé qu’au premier bâtiment"
    },
    "v1_3_0": {
      "i0": "Le jeu a enfin une musique — active-la dans les réglages",
      "i1": "Elle ne se répète jamais, et elle suit le cycle du jour"
    },
    "v1_2_0": {
      "i0": "Rien ne change dans le jeu : ménage côté serveur"
    },
    "v1_1_0": {
      "i0": "Les vides entre tes bâtiments deviennent des jardins"
    },
    "v1_0_0": {
      "i0": "Les rues ont enfin des trottoirs, et elles occupent toute leur case",
      "i1": "Plus de bande d’herbe entre la chaussée et tes bâtiments"
    },
    "v0_99_1": {
      "i0": "Rien ne change dans le jeu : préparation de la passe visuelle des routes"
    },
    "v0_99_0": {
      "i0": "Tape un arbre ou un rocher : tu peux le défricher contre des pièces",
      "i1": "Et si tu te ravises, la nature revient"
    },
    "v0_98_0": {
      "i0": "Un classement mondial : ta place, et les cinquante meilleures villes",
      "i1": "Il se lit dans Progression, onglet Classement"
    },
    "v0_97_0": {
      "i0": "Partager un lien vers Villopia affiche enfin une image de ville, pas une vignette",
      "i1": "Le site se laisse mieux trouver : titre, description et plan du site"
    },
    "v0_96_1": {
      "i0": "Les pages de mentions légales et le tableau de bord défilent à nouveau"
    },
    "v0_96_0": {
      "i0": "Rien ne change dans le jeu : le tableau de bord interne ne tronque plus ses chiffres"
    },
    "v0_95_0": {
      "i0": "Rien ne change dans le jeu : le tableau de bord sépare les vrais joueurs des robots",
      "i1": "Cinq cents villes par jour, c'étaient les sondes"
    },
    "v0_94_1": {
      "i0": "Rien ne change dans le jeu : le tableau de bord interne sait dire pourquoi il est vide",
      "i1": "Un zéro et une lecture échouée ne se ressemblent plus"
    },
    "v0_94_0": {
      "i0": "Rien ne change dans le jeu : c'est le tableau de bord interne qui gagne ses graphiques",
      "i1": "Courbes sur trente jours, revenus, joueurs par ère"
    },
    "v0_93_0": {
      "i0": "Manquer de pièces ouvre enfin de quoi y remédier, au lieu de s'arrêter sur un constat",
      "i1": "Et le jeu sait mesurer sa propre santé — sans cookie, sans bannière"
    },
    "v0_92_1": {
      "i0": "Un point de repère trop cher te le dit AVANT que tu vises ta case",
      "i1": "Fini la boutique qui s'ouvre sans un mot quand tu essayes de poser"
    },
    "v0_92_0": {
      "i0": "Touche un bâtiment : tu vois enfin ce qu'il te rapporte, et pourquoi un autre est verrouillé",
      "i1": "Le lot passe à ×5 — le nombre qui débloque le bâtiment suivant"
    },
    "v0_91_0": {
      "i0": "Les onglets restent visibles quand tu fais défiler un menu",
      "i1": "Et Bricolo laisse le temps de le lire : neuf secondes au lieu d'une et demie"
    },
    "v0_90_2": {
      "i0": "La fenêtre des réglages est de nouveau centrée — elle se collait à gauche",
      "i1": "Sur téléphone rien n'avait changé, le défaut ne se voyait qu'en grand écran"
    },
    "v0_90_1": {
      "i0": "Plus de glissement latéral dans les réglages — il tenait à deux pixels",
      "i1": "Et la boîte est plus large sur grand écran : 520 px au lieu de 400"
    },
    "v0_90_0": {
      "i0": "Les réglages se lisent enfin en colonne : tout est aligné, plus rien n'est coupé",
      "i1": "Et l'e-mail tient sur une seule ligne avec son bouton"
    },
    "v0_89_1": {
      "i0": "L'éditeur est Ludopia.fr — l'extension était fausse",
      "i1": "Rien d'autre ne bouge"
    },
    "v0_89_0": {
      "i0": "Les réglages se rangent en quatre sections : Langue, Compte, Préférences, À propos",
      "i1": "Et le jeu nomme enfin son éditeur — Ludopia.app"
    },
    "v0_88_0": {
      "i0": "Tu peux maintenant choisir de recevoir les nouveautés par e-mail — case séparée, décochée",
      "i1": "Se désabonner tient en un tap, et ta ville te suit que tu coches ou non"
    },
    "v0_87_0": {
      "i0": "World Blocks rejoint « Mes jeux » — puzzle de blocs et construction de villes",
      "i1": "Et les accroches tiennent enfin sur deux lignes au lieu d'être coupées en plein mot"
    },
    "v0_86_0": {
      "i0": "Un point de repère ajoute une part de ce que ta ville produit déjà — et sa carte affiche le gain réel",
      "i1": "Il accompagne ta partie au lieu de la remplacer : une ère reste une ère"
    },
    "v0_85_1": {
      "i0": "Un repère posé porte enfin son nom partout, pas seulement en boutique",
      "i1": "Et son panneau ne propose plus d'amélioration : il est unique tel quel"
    },
    "v0_85_0": {
      "i0": "Tu choisis maintenant OÙ poser ton point de repère — et tu ne paies qu'à la pose",
      "i1": "Et il ne disparaît plus : un repère ne s'améliore pas, il est unique tel quel"
    },
    "v0_84_2": {
      "i0": "Le calcul de production allège son travail quand tu n'as pas encore de point de repère",
      "i1": "Rien ne change à l'écran — le jeu tourne juste un peu plus léger"
    },
    "v0_84_1": {
      "i0": "Un point de repère qui refuse dit maintenant pourquoi : « il te manque 12 💎 »",
      "i1": "Et s'il ne dit rien, c'est qu'il manque de la place, pas des gemmes"
    },
    "v0_84_0": {
      "i0": "Le menu du bas est enfin lisible sur téléphone : trois bâtiments entiers, plus rien de coupé",
      "i1": "Et quand tu choisis un bâtiment, ×1 ×10 ×MAX s'affichent tout de suite"
    },
    "v0_83_0": {
      "i0": "Quatre points de repère en gemmes : château d'eau, aire de jeux, piscine, héliport",
      "i1": "Un seul de chaque par ère — et ils valent plusieurs fois ton meilleur bâtiment"
    },
    "v0_53_0": {
      "i0": "Tes gemmes servent enfin : avance ta production, rachète ta nuit, change tes quêtes.",
      "i1": "Une chaîne rompue se rétablit — une fois par semaine, le jour même.",
      "i2": "Le prix du terrain en gemmes s’affiche là où tu manques de place.",
      "i3": "Termine le guide de Bricolo : ton premier ×2 est offert."
    },
    "v0_52_0": {
      "i0": "Trois accélérations au choix : ×2 pendant 30 min, ×3 pendant 2 h, ×5 pendant 8 h",
      "i1": "Ta pub gratuite et ton accélération achetée se cumulent enfin, au lieu de s’évincer",
      "i2": "Chaque bonus actif affiche son propre compte à rebours dans le bandeau"
    },
    "v0_51_0": {
      "i0": "Tous les boutons du jeu sont enfin taillés pour le pouce — compteur de gemmes et tutoriel compris"
    },
    "v0_50_0": {
      "i0": "Mentions légales, confidentialité et conditions de vente sont en ligne — depuis les Réglages",
      "i1": "Tu sais exactement quelles données Villopia garde : très peu, et jamais ton identité"
    },
    "v0_49_1": {
      "i0": "Les publicités récompensées disent toujours ce qui se passe — et ton quota reste intact si aucune pub n’est disponible"
    },
    "v0_49_0": {
      "i0": "La boutique de gemmes ouvre pour de bon — paiement sécurisé par Stripe",
      "i1": "Un achat validé te retrouve toujours, même si tu fermes le jeu en cours de route"
    },
    "v0_48_0": {
      "i0": "Ta ville en chiffres, le renommage, ton livre des jalons et ta division arrivent à l’écran",
      "i1": "« Tes visiteurs » affiche enfin ton compte et ton prochain trophée"
    },
    "title": "Nouveautés",
    "open": "Nouveautés de la version {value}",
    "current": "version actuelle",
    "v0_47_2": {
      "i0": "La lumière du lampadaire jaillit de sa lanterne et rayonne derrière elle",
      "i1": "Les feux allument leur vraie ampoule : rouge en haut, ambre au milieu, verte en bas"
    },
    "v0_47_1": {
      "i0": "Chaque halo est posé PILE sur sa lanterne — mesuré au pixel, rotation par rotation",
      "i1": "L'éclairage bat son plein au crépuscule et à l'aube, se tamise la nuit, s'efface le jour"
    },
    "v0_47_0": {
      "i0": "La nuit, les fenêtres s'éteignent et se rallument au fil des heures — ta ville vit",
      "i1": "Les lampadaires éclairent enfin, d'un halo chaud qui naît au crépuscule",
      "i2": "Plus aucune lumière fantôme après un déplacement ou un pivot"
    },
    "v0_46_0": {
      "i0": "Les feux et panneaux retrouvent une taille humaine, à hauteur de lampadaire",
      "i1": "Les voitures ne se chevauchent plus : voies écartées, et on attend que le carrefour soit libre",
      "i2": "Les abords des carrefours sont dégagés — la signalisation y respire"
    },
    "v0_45_0": {
      "i0": "Les feux tricolores arrivent VRAIMENT : les carrefours en T alternent feux et stops",
      "i1": "Plus aucune voiture garée au milieu d'un croisement — on dégage toujours le carrefour",
      "i2": "Les lampadaires se collent au bord de la chaussée"
    },
    "v0_44_0": {
      "i0": "L'onglet Social affiche les membres Discord et les abonnés YouTube et TikTok"
    },
    "v0_43_0": {
      "i0": "Les feux tricolores s'allument enfin : vert, ambre, rouge — les voitures obéissent à ce que tu vois",
      "i1": "Jusqu'à 40 véhicules en circulation : plus ta ville grandit, plus elle roule",
      "i2": "Les feux passent au vert plus vite : fini les attentes interminables aux carrefours",
      "i3": "Lampadaires et bancs sont collés à la route, pour toujours — aucun bâtiment ne les délogera"
    },
    "v0_42_1": {
      "i0": "L'en-tête reste sur une ligne quand la place suffit, tes boosts à côté de ta production",
      "i1": "Poser un bâtiment sur un lampadaire ou un banc le retire pour de bon"
    },
    "v0_42_0": {
      "i0": "La boutique de gemmes tient dans l'écran et défile enfin partout",
      "i1": "Sur téléphone, tes boosts actifs ne cachent plus le haut de l'écran",
      "i2": "Discord, YouTube et TikTok t'attendent dans l'onglet Social",
      "i3": "L'onglet Progression s'illumine quand une nouvelle ère est prête"
    },
    "v0_41_0": {
      "i0": "Dans les coulisses : un tableau de bord pour veiller sur la santé du jeu"
    },
    "v0_40_0": {
      "i0": "La boutique devient une vraie vitrine : grand cristal, tas de gemmes qui grossissent, pack populaire doré",
      "i1": "Ton trésor s'affiche en grand, et chaque offre montre ce qu'elle vaut",
      "i2": "Rejoins le Discord de Villopia depuis l'onglet Social !"
    },
    "v0_39_0": {
      "i0": "Bricolo, ton contremaître, t'accueille et te fait visiter — pas à pas, sans jamais bloquer",
      "i1": "Construire, agrandir, t'inscrire, regarder une pub : chaque étape se valide quand tu la fais"
    },
    "v0_38_0": {
      "i0": "La boutique fait peau neuve — plus large, plus claire, durées propres",
      "i1": "Le paiement des packs arrive : la chaîne est en place, l'ouverture est proche"
    },
    "v0_37_0": {
      "i0": "Regarde une publicité, gagne ×2 de production pendant 1 h — trois fois par jour",
      "i1": "L'offre vit dans la boutique de gemmes, c'est la seule gratuite"
    },
    "v0_36_0": {
      "i0": "Les souvenirs de visiteurs se vendent et se déplacent — touche-les !",
      "i1": "Deux sortes de jardinières alternent, et chaque nouveau souvenir tombe du ciel",
      "i2": "Au prestige, les souvenirs de tes visiteurs repoussent dans la nouvelle ère"
    },
    "v0_35_0": {
      "i0": "Chaque multiplicateur affiche son temps restant — accélérations et boosts de visite"
    },
    "v0_34_0": {
      "i0": "« Mes jeux » a son propre onglet dans la barre de navigation",
      "i1": "Sur ordinateur, la boutique reste pleine pendant la pose — fini le grand vide",
      "i2": "Les boutons de pose vivent en tête de la boutique, toujours à portée"
    },
    "v0_33_1": {
      "i0": "Le bâtiment choisi reste visible pendant la pose — en vitrine dans la barre d'action",
      "i1": "Un onglet « Mes autres jeux » apparaît sous Progression"
    },
    "v0_33_0": {
      "i0": "En boutique, le bâtiment choisi tourne lentement pour se montrer sous toutes ses faces"
    },
    "v0_32_0": {
      "i0": "Au retour d'une absence, tes gains pleuvent du ciel et filent vers ton compteur"
    },
    "v0_31_0": {
      "i0": "L'écran tremble aux grands moments — prestige, premier jalon, nouveau terrain — et seulement là"
    },
    "v0_30_0": {
      "i0": "Chaque visiteur laisse une jardinière dorée sur ta ville",
      "i1": "À 25 visiteurs un banc apparaît, à 100 une fontaine — partage ton lien !"
    },
    "v0_29_0": {
      "i0": "Tes visiteurs découvrent ta ville à l'heure dorée, en approche lente de quatre secondes",
      "i1": "Et ses rues leur paraissent trois fois plus vivantes"
    },
    "v0_28_0": {
      "i0": "Chaque jalon éclate en gerbe de particules — et des confettis saluent le premier de la session",
      "i1": "Au prestige, ta ville s'envole bâtiment par bâtiment avant de renaître",
      "i2": "Un bâtiment qui se débloque entre en scène dans la boutique"
    },
    "v0_27_0": {
      "i0": "Les bâtiments voisins s'écartent doucement pour faire place à ce que tu poses"
    },
    "v0_26_0": {
      "i0": "Chaque gain jaillit du bâtiment qui le produit — « +12,4 k » monte et s'évanouit",
      "i1": "Plus le gain est gros, plus il s'écrit grand"
    },
    "v0_25_0": {
      "i0": "Ta ville est désormais sauvegardée en double exemplaire, chacun scellé",
      "i1": "Un onglet fermé brutalement ne peut plus abîmer ta partie"
    },
    "v0_24_4": {
      "i0": "Une erreur technique s'affichait dans la console à chaque chargement — corrigée",
      "i1": "Les images du jeu reprennent leur chemin de chargement rapide"
    },
    "v0_24_3": {
      "i0": "Les confirmations importantes pré-sélectionnent toujours le bouton sans danger, dans toutes les langues"
    },
    "v0_24_2": {
      "i0": "Chaque mise à jour est désormais vérifiée automatiquement avant d'arriver en ligne"
    },
    "v0_24_1": {
      "i0": "Poser le doigt pendant le chargement de l'aperçu est maintenant pris en compte"
    },
    "v0_24_0": {
      "i0": "Chaque nouvelle ère débloque un bâtiment inédit dès la première seconde",
      "i1": "L'écran de prestige annonce ce que la prochaine ère t'offrira",
      "i2": "Les fenêtres attendent la vraie nuit pour s'allumer, en douceur"
    },
    "v0_23_0": {
      "i0": "La nuit, les fenêtres de ta ville s'allument — et pas toutes en même temps"
    },
    "v0_22_0": {
      "i0": "Attrape un bâtiment et fais-le glisser : il se pose où tu relâches",
      "i1": "Un appui long sur un bâtiment posé le décolle — plus besoin de menu",
      "i2": "Une grille et une empreinte verte ou rouge apparaissent pendant la pose",
      "i3": "Pendant que tu poses, la vue ne glisse plus sous tes doigts"
    },
    "v0_21_0": {
      "i0": "Tes quêtes de terrain ne sont plus cassées après un prestige",
      "i1": "Chaque nouvelle ère repart vraiment plus vite : 2,2 h, puis 1,5 h, puis 1,1 h"
    },
    "v0_20_0": {
      "i0": "Le compteur de visites augmente enfin — et avec lui les gemmes qu'il rapporte",
      "i1": "Le premier prestige demande maintenant une vraie partie, pas trente minutes",
      "i2": "Poser dix bâtiments d'un coup, ou autant que ta bourse le permet",
      "i3": "Ta ville ne clignote plus quand elle se recharge"
    },
    "v0_19_0": {
      "i0": "Un réglage de volume, un écran de crédits, et la possibilité de tout recommencer",
      "i1": "Le zoom du navigateur n'est plus bloqué, et la ville a un nom pour les lecteurs d'écran",
      "i2": "Les boîtes de confirmation focalisent enfin le bouton qui ne casse rien"
    },
    "v0_18_0": {
      "i0": "Chaque visite sur ta ville booste ta production pendant 2 h",
      "i1": "Le visiteur voit qu'il vient de t'aider — et ça donne envie de jouer",
      "i2": "Ton lien affiche enfin ce qu'il te rapporte"
    },
    "v0_17_0": {
      "i0": "Le prestige est là : recommence ta ville et garde un bonus permanent",
      "i1": "Tes gemmes servent enfin à quelque chose — accélération et terrain",
      "i2": "Améliorer un bâtiment coûte désormais le prix du moment, pas un prix bradé",
      "i3": "Les objectifs du jour ne tournent plus en boucle tous les trois jours"
    },
    "v0_16_0": {
      "i0": "Les rues forment enfin un vrai réseau, et les voitures y roulent",
      "i1": "Plus de bouts de bitume isolés au milieu des maisons",
      "i2": "Un bâtiment déplacé garde sa desserte : la rue le suit",
      "i3": "Tu peux retirer une rue en la touchant",
      "i4": "Les villes déjà construites sont réparées au chargement"
    },
    "v0_15_0": {
      "i0": "Déplacer la caméra ne pose plus de bâtiment par accident",
      "i1": "Un achat refusé dit enfin pourquoi : trop cher, case prise, ou plus de place",
      "i2": "Vendre demande confirmation, et annonce ce que ça rapporte",
      "i3": "Échap ou un doigt hors de l'île annule une pose en cours"
    },
    "v0_14_0": {
      "i0": "Un bouton « Rafraîchir » apparaît dès qu'une nouvelle version est disponible"
    },
    "v0_13_1": {
      "i0": "Le tiroir fermé ne laisse plus dépasser un liseré derrière la barre du bas"
    },
    "v0_13_0": {
      "i0": "Choix des bâtiments en carrousel, et une invitation à installer le jeu sur ton écran d'accueil"
    },
    "v0_12_0": {
      "i0": "Une seule barre en haut, deux fois plus fine, et le menu se cache pour laisser voir ta ville"
    },
    "v0_11_0": {
      "i0": "Bandeau du haut resserré : plus de place pour la ville, et les panneaux ont enfin du relief"
    },
    "v0_10_5": {
      "i0": "Cette fois pour de bon : plus d'écran de chargement figé après une mise à jour"
    },
    "v0_10_4": {
      "i0": "Une mise à jour ne casse plus le jeu : la nouvelle version se charge toute seule"
    },
    "v0_10_3": {
      "i0": "Une seule adresse pour ta ville : les anciens liens t’y ramènent tout seuls"
    },
    "v0_10_2": {
      "i0": "Téléphone à l’horizontale : la ville reste visible, le panneau se pose à côté d’elle"
    },
    "v0_10_1": {
      "i0": "Le titre du tiroir suit enfin l’onglet ouvert",
      "i1": "Plus d’écran d’attente au-dessus du contenu qu’il annonçait"
    },
    "v0_10_0": {
      "i0": "L’onglet Social existe enfin : ton lien public, et un bouton pour l’envoyer",
      "i1": "Sur téléphone le partage passe par WhatsApp, SMS ou Instagram en un geste",
      "i2": "Sur ordinateur le lien se copie tout seul — et si rien ne marche, il reste sélectionnable"
    },
    "v0_9_1": {
      "i0": "Une pastille BÊTA en haut : la ville est un chantier, et ça se dit"
    },
    "v0_9_0": {
      "i0": "La ville se charge quatre fois plus vite : les sprites tiennent dans un atlas compressé",
      "i1": "Ton téléphone ne télécharge que les bâtiments que tu possèdes vraiment",
      "i2": "Un seul lot de rendu par feuille au lieu d’un par sprite : la ville respire mieux"
    },
    "v0_8_3": {
      "i0": "Plus de socle sous les bâtiments : la dalle de parcelle est retirée"
    },
    "v0_8_2": {
      "i0": "Chaque bâtiment repose sur une parcelle pavée : le terrain qu’on achète se voit enfin",
      "i1": "Vendre un bâtiment rend sa parcelle à l’herbe"
    },
    "v0_8_1": {
      "i0": "Tous les bâtiments partagent la même échelle : fenêtres, portes et étages à la bonne taille partout",
      "i1": "Plus aucun bâtiment ne déborde de sa parcelle sur ses voisins",
      "i2": "Les hauteurs redeviennent naturelles : on voit de nouveau la ville derrière les tours",
      "i3": "Les sprites ne restent plus en cache d’une version à l’autre — fin des bâtiments qui flottent"
    },
    "v0_8_0": {
      "i0": "Chaque bâtiment occupe enfin la largeur de sa parcelle — une échoppe ne dépasse plus une clinique",
      "i1": "Les tours sont des tours : plus de plafond qui écrasait les grands bâtiments",
      "i2": "Le soleil vient de la droite pour toute la ville, toits et murs compris",
      "i3": "Auvents, balcons et casquettes de toit portent leur ombre : les volumes se lisent",
      "i4": "Ciel bleu au-dessus, lumière chaude renvoyée par le sol : les façades respirent"
    },
    "v0_2_0": {
      "i0": "Le bandeau du haut ne couvre plus la ville sur téléphone",
      "i1": "Les jalons se récompensent dès qu’ils sont atteints, même sans poser",
      "i2": "Plus de quête impossible tant que les visites n’existent pas encore",
      "i3": "L’application s’installe enfin sur téléphone (PWA)",
      "i4": "Correction d’un plantage du rendu pendant l’animation de pose",
      "i5": "Console propre : l’audio ne démarre plus avant le premier geste"
    },
    "v0_1_0": {
      "i0": "La ville isométrique : dix bâtiments, routes automatiques, paliers visuels",
      "i1": "L’économie : pièces, gemmes, jalons, extensions de terrain",
      "i2": "Quêtes du jour, objectifs de la semaine, chaîne de connexion",
      "i3": "Sauvegarde locale et compteur de joueurs en ligne"
    },
    "v0_3_0": {
      "i0": "Ta ville se sauvegarde en ligne et reçoit son adresse publique",
      "i1": "Relie un e-mail dans Réglages pour retrouver ta ville partout",
      "i2": "La page de visite : ta ville animée, ouverte au monde",
      "i3": "Le numéro de version en bas d’écran ouvre ces nouveautés"
    },
    "v0_4_0": {
      "i0": "Déplacer un grand bâtiment d’une seule case fonctionne enfin",
      "i1": "Un bâtiment ne peut plus être reposé sur une route",
      "i2": "Le jeu prévient quand il n’arrive pas à sauvegarder, au lieu de perdre ta partie en silence",
      "i3": "Plus de rendu figé si tu vends un bâtiment pendant que sa route se trace",
      "i4": "Le bandeau du haut occupe 25 % de l’écran au lieu de 43 % — toute l’info, plus de ville",
      "i5": "Deux bâtiments posés dans la même seconde ne partagent plus d’identité",
      "i6": "Tes monuments d’héritage ne seront plus effacés au rechargement"
    },
    "v0_5_0": {
      "i0": "Le pivot de vue ne casse plus rien : routes, arbres et rochers tournent avec le sol",
      "i1": "Les bâtiments ne passent plus derrière la tuile qui les porte après un quart de tour",
      "i2": "Les voitures sont enfin visibles — elles étaient dessinées sous le sol",
      "i3": "L’aperçu de placement montre le VRAI modèle qui sera posé (palier, variante, orientation)",
      "i4": "Les pièces décollent du centre du bâtiment, plus du vide",
      "i5": "Bandeau du haut : 21 % de l’écran sur mobile, une seule bande sur ordinateur"
    },
    "v0_6_0": {
      "i0": "Ta ville produit pendant ton absence — et te raconte ce qui s’est passé au retour",
      "i1": "Un onglet laissé ouvert ne rapporte plus douze fois trop : le temps loin de l’écran compte comme du hors-ligne",
      "i2": "Les quêtes basculent à minuit même sans recharger la page, et la chaîne de connexion ne se casse plus",
      "i3": "Reculer l’horloge du téléphone ne permet plus de réencaisser les quêtes en boucle",
      "i4": "Bandeau du haut réorganisé : pièces et gemmes sur une ligne, plus de texte coupé en fin de partie"
    },
    "v0_6_1": {
      "i0": "Lampadaires, bancs et poubelles bordent enfin tes rues — ils étaient livrés mais jamais posés",
      "i1": "Le décor distingue la ville de la campagne : mobilier urbain le long du bitume, nature ailleurs"
    },
    "v0_6_2": {
      "i0": "Poubelles, bancs et lampadaires à leur vraie taille — une poubelle faisait la taille d’un arbre",
      "i1": "Le mobilier urbain s’oriente enfin vers la rue qu’il borde"
    },
    "v0_7_0": {
      "i0": "Une règle unique de proportions pour tous les décors — plus de poubelle grosse comme un arbre",
      "i1": "Lampadaires et bancs collés au trottoir, orientés vers la rue qu’ils bordent",
      "i2": "Bandeau du haut : ligue, visiteurs et joueurs en ligne enfin alignés sur une seule ligne"
    },
    "v0_7_1": {
      "i0": "Des lampadaires tout le long des rues, à intervalle régulier — c’est la cadence qui fait une rue"
    },
    "v0_7_2": {
      "i0": "Le bouton « + » des gemmes ne déborde plus du bandeau"
    },
    "v0_7_3": {
      "i0": "Plus d’arbres plantés le long du bitume : une case qui devient bord de rue reçoit son mobilier urbain"
    },
    "v0_61_0": {
      "i0": "Un nouveau jeu dans « Mes jeux » : Tradopia, pour apprendre la bourse en jouant"
    },
    "v0_60_0": {
      "i0": "La boutique de gemmes prend des couleurs : chaque pack porte la sienne, du plus petit au plus généreux",
      "i1": "L'offre de pub ne s'écrase plus en colonne illisible sur téléphone"
    },
    "v0_59_0": {
      "i0": "Quand il te manque des gemmes, le bouton t'emmène à la boutique au lieu de refuser"
    },
    "v0_58_0": {
      "i0": "Ce qui cache le bâtiment que tu manipules devient transparent — tu vois enfin ce que tu touches"
    },
    "v0_57_1": {
      "i0": "Les barres de défilement portent enfin les couleurs du jeu"
    },
    "v0_57_0": {
      "i0": "Tes bâtiments ne sont plus posés sur une dalle grise : ils touchent le sol, comme les routes"
    },
    "v0_56_0": {
      "i0": "Une carte trop chère ne reste plus muette : elle affiche ce qu'il te manque et te propose de compléter en gemmes",
      "i1": "Le prix se lit sur la carte AVANT de la toucher — « prêt dans 40 s · ou 2 💎 »"
    },
    "v0_55_1": {
      "i0": "Tu peux enfin aller partout sur la carte — chaque angle de ta ville se ramène au milieu de l'écran"
    },
    "v0_55_0": {
      "i0": "Plus aucune parcelle coincée sous le menu : la ville se déplace librement, sans jamais sortir de l'écran",
      "i1": "Le bouton qui faisait pivoter la vue d'un quart de tour a été retiré"
    },
    "v0_54_6": {
      "i0": "Le bouton « Regarder une pub » ne donnait rien en ligne — il rend de nouveau son bonus"
    },
    "v0_54_5": {
      "i0": "Une seconde erreur silencieuse au démarrage a été trouvée et corrigée : la console est de nouveau vide"
    },
    "v0_54_4": {
      "i0": "Une erreur traînait dans la console à chaque ouverture du jeu — elle a disparu"
    },
    "v0_54_3": {
      "i0": "Ton compteur de visites était muet pendant une heure ce matin — réparé, et une sonde le surveille désormais"
    },
    "v0_54_2": {
      "i0": "Rien de neuf à l'écran : la sonde qui surveille l'éclairage de nuit mesurait mal, elle est réparée"
    },
    "v0_54_1": {
      "i0": "Ton identifiant de compte cesse d'être visible depuis l'extérieur : plus personne ne peut relier ta ville à toi"
    },
    "v0_54_0": {
      "i0": "Tes gemmes achetées sont désormais gardées par le serveur : vider ton navigateur ne te les fait plus perdre",
      "i1": "Elles reviennent toutes seules au chargement, sur n'importe quel appareil où tu es connecté"
    },
    "v0_53_1": {
      "i0": "Tes parties d’avant sont blindées : un contrôle automatique vérifie à chaque version qu’aucune sauvegarde ne perd quoi que ce soit",
      "i1": "Rien de neuf à l’écran — ce lot met en ligne les gemmes, les accélérations et les menus livrés hier"
    },
    "v0_62_0": {
      "i0": "Douze décorations à poser dans ta ville, en gemmes : arbres, banc, lampadaire, fontaine…",
      "i1": "Elles ne rapportent rien et c'est voulu — et elles survivent au changement d'ère"
    },
    "v0_63_0": {
      "i0": "Construction se range en onglets : Bâtiments d'un côté, Décorations de l'autre"
    },
    "v0_63_1": {
      "i0": "Les onglets filtrent vraiment, et ils ont enfin l'allure du reste du jeu"
    },
    "v0_63_2": {
      "i0": "Les décorations achetées apparaissent toutes sur ta ville — neuf sur douze restaient invisibles",
      "i1": "Ce que tu as payé en gemmes reste à toi, même après un rechargement"
    },
    "v0_64_0": {
      "i0": "Tu choisis maintenant OÙ poser une décoration, comme pour un bâtiment",
      "i1": "Un sac à dos garde tout ce que tu as payé — au changement d'ère, rien ne se perd",
      "i2": "Ta ville est pleine ? Achète quand même : ta décoration t'attendra dans le sac"
    },
    "v0_65_0": {
      "i0": "Une décoration achetée se revend maintenant, au prorata de ce qu'elle t'a coûté"
    },
    "v0_66_0": {
      "i0": "La fontaine devient une pièce d'exception à viser — le catalogue va de 4 à 300 gemmes",
      "i1": "Le bosquet reste à 4 gemmes : la porte d'entrée ne bouge pas"
    },
    "v0_67_0": {
      "i0": "Tes décorations s'affichent enfin sur ta page publique — c'est ce que tes amis voient",
      "i1": "Les fleurs laissées par tes visiteurs aussi"
    },
    "v0_67_1": {
      "i0": "Impossible de construire sur une décoration : elle occupe sa case, comme une rue",
      "i1": "Les décorations déjà recouvertes ressortent au chargement — elles redeviennent vendables"
    },
    "v0_68_0": {
      "i0": "Un bâtiment trop cher à améliorer ? Monte-le au niveau max en gemmes, en un tap",
      "i1": "Le prix est celui de l'attente que tu t'épargnes — ni plus, ni moins"
    },
    "v0_82_0": {
      "i0": "Les onglets se ressemblent enfin d'un menu à l'autre — même taille, même icône, même pastille",
      "i1": "Et ceux de Construire sont plus faciles à toucher : 48 px au lieu de 40"
    },
    "v0_81_1": {
      "i0": "Plus aucune erreur rouge dans la console : le jeu ne réclame plus ce qui n'existe pas",
      "i1": "Rien ne change à l'écran — c'est de la propreté sous le capot"
    },
    "v0_81_0": {
      "i0": "Le parcours d'achat est réparé : les packs revivent derrière leur onglet",
      "i1": "Et l'invitation à créer un compte ne s'ouvre plus jamais sur un formulaire vide"
    },
    "v0_80_0": {
      "i0": "Laisse ton e-mail et ta ville te suit sur tous tes écrans — proposé trois fois, jamais imposé",
      "i1": "Refusé ? Le jeu se tait une semaine. Il se joue toujours sans compte"
    },
    "v0_79_0": {
      "i0": "Chaque ère a sa lumière : le ciel change de teinte quand tu recommences",
      "i1": "Et ta page publique montre TA lumière à ceux qui viennent voir"
    },
    "v0_78_0": {
      "i0": "La boutique se sépare en deux : Dépenser d'un côté, Obtenir des gemmes de l'autre",
      "i1": "Et le lien TikTok pointe enfin au bon endroit"
    },
    "v0_77_0": {
      "i0": "La section Ville aussi : Résumé, Terrain, Vue — chacun sous son onglet"
    },
    "v0_76_0": {
      "i0": "Progression se range en onglets : Quêtes, Jalons, Ères — comme Construire",
      "i1": "Et quand le jeu te propose quelque chose, il t'ouvre le bon onglet"
    },
    "v0_75_0": {
      "i0": "Dix-neuf jalons de plus : ton réseau de rues, tes décorations, tes ères",
      "i1": "Ce que tu as déjà accompli te sera crédité au chargement"
    },
    "v0_74_0": {
      "i0": "Le livre des jalons s'ouvre : touche une famille et vois ce qui t'attend",
      "i1": "Et ce qu'il ne montre pas, il te le dit — la liste ne s'épuise jamais"
    },
    "v0_73_0": {
      "i0": "Bricolo reste avec toi : il te dit toujours quoi faire ensuite, et t'y emmène",
      "i1": "Un tap le réduit en pastille — et il se souvient que tu l'as rangé"
    },
    "v0_72_1": {
      "i0": "Au cœur d'un quartier dense, les carrefours ont enfin leurs feux et leurs stops"
    },
    "v0_72_0": {
      "i0": "Les rues qui ne desservent plus rien se retirent d'un geste — le terrain revient",
      "i1": "Aucune rue utile n'est touchée, et le réseau reste d'un seul tenant"
    },
    "v0_71_0": {
      "i0": "Quand une nouvelle ère s'ouvre, un bandeau te le dit — avec le bonus chiffré",
      "i1": "Tu peux le refermer : il ne revient pas, et la prochaine ère le rouvre"
    },
    "v0_70_0": {
      "i0": "Les bâtiments améliorés portent leur palier : deux points, trois points, au-dessus du toit"
    },
    "v0_69_0": {
      "i0": "Les bâtiments à débloquer affichent enfin ce qui te manque : « 3/5 » et une barre",
      "i1": "Et quand la porte s'ouvre, on te le dit — même si tu regardais ta ville"
    }
  },
  "accountInvite": {
    "title": "Garde ta ville",
    "later": "Plus tard",
    "shared": "Ton lien est parti ! Laisse ton e-mail et ta ville te suivra sur ton téléphone, ton ordinateur, partout — même si tu changes d'appareil.",
    "era": "Nouvelle ère franchie, et ton bonus est permanent. Un e-mail suffit pour qu'il ne dépende plus de ce seul navigateur.",
    "purchase": "Avant de payer : laisse ton e-mail. Des gemmes achetées sur un navigateur qu'on vide, ce sont des gemmes qu'on retrouve mal."
  },
  "account": {
    "title": "Compte",
    "anonymousHint": "Ta ville est liée à ce navigateur. Ajoute un e-mail pour la retrouver partout.",
    "emailPlaceholder": "ton@email.fr",
    "sendLink": "M’envoyer un lien",
    "linkSent": "Lien envoyé ! Ouvre l’e-mail pour relier ta ville.",
    "linkError": "L’envoi a échoué. Vérifie l’adresse et réessaie.",
    "connectedAs": "Ville reliée à {value}",
    "newsletter": "Je veux recevoir les nouveautés de Villopia par e-mail (facultatif)",
    "newsletterHint": "Rien à voir avec ta sauvegarde : ta ville te suit que tu coches ou non.",
    "newsletterOn": "C'est noté, tu recevras les nouveautés.",
    "newsletterOff": "C'est noté, tu ne recevras plus rien.",
    "newsletterError": "Impossible d'enregistrer ton choix. Réessaie."
  },
  "visit": {
    "by": "Une ville Villopia",
    "cta": "Crée ta ville — gratuit",
    "prestige": "Ère {value}",
    "rank": "{rank}e sur {total} villes classées",
    "rankFirst": "1re ville du classement mondial",
    "live": "{value} personnes regardent cette ville en ce moment",
    "notFound": "Cette ville n’existe pas (ou plus).",
    "notFoundHint": "Vérifie le lien… ou fonde la tienne, c’est gratuit et sans compte.",
    "boosted": "Ta visite vient de booster cette ville — merci !",
    "legal": "Informations légales"
  },
  "offline": {
    "welcomeBack": "Content de te revoir !",
    "earned": "+{value} pièces produites pendant ton absence ({duration})",
    "lead": "Pendant ton absence — {duration} — ta ville a continué de tourner.",
    "collect": "Encaisser",
    "efficiency": "Une ville sans toi produit à {value} % de son rythme.",
    "capped": "{duration} de plus n’ont pas été comptées : la production hors-ligne est plafonnée.",
    "nightOffer": "Récupérer ces {duration} · {value} 💎",
    "nightUsed": "Nuit blanche dépensée : 24 h comptées, à moitié tarif."
  },
  "social": {
    "waitingTitle": "Ta ville se réserve son adresse",
    "waitingText": "Encore quelques secondes, et tu auras un lien à envoyer. Chaque personne qui l’ouvre fait produire ta ville plus vite.",
    "shareTitle": "Partager ta ville",
    "pitch": "Chaque visiteur unique double ta production pendant deux heures.",
    "rewarded": "Merci ! +{value} 💎",
    "rewardedText": "Il te reste {value} 💎 à prendre sur les autres réseaux.",
    "linkLabel": "Lien public de ta ville",
    "shareAction": "Envoyer le lien",
    "hint": "Le visiteur voit ta ville animée, en direct. Pas besoin de compte pour la regarder.",
    "shareSubject": "Villopia — {name}",
    "shareText": "Viens voir {name}, ma ville sur Villopia. Ta visite la fait grandir.",
    "copied": "Lien copié",
    "selectManually": "Copie le lien affiché",
    "discord": "Rejoindre le Discord de Villopia",
    "discordName": "Discord",
    "youtube": "La chaîne YouTube de Villopia",
    "youtubeName": "YouTube",
    "tiktok": "Le TikTok de Villopia",
    "tiktokName": "TikTok",
    "members": "{value} membres",
    "followers": "{value} abonnés",
    "preview": "Voir ma page publique",
    "visitorsTitle": "Tes visiteurs",
    "visitorsCount": "{value} visiteurs reçus",
    "tierNext": "Encore {value} visiteurs et ta ville gagne {name}",
    "tierAll": "Tous les trophées de visiteurs sont posés — chaque visite continue de te booster",
    "tier": {
      "bench": "un banc d’honneur",
      "fountain": "une fontaine",
      "arch": "une arche",
      "goldenStatue": "une statue dorée"
    }
  },
  "prestige": {
    "title": "Nouvelle ère",
    "readyTitle": "Une nouvelle ère t'attend",
    "readyText": "Ton bonus permanent passerait à ×{value}. Ta ville repart, le bonus reste.",
    "readyAction": "Voir",
    "era": "Ère {value} · bonus permanent ×{multiplier}",
    "pitch": "Recommence ta ville depuis le début, et garde un bonus de production pour toujours. Chaque ère va plus vite que la précédente.",
    "becomes": "ton bonus passe de ×{from} à ×{to}",
    "locked": "Encore {value} pièces à produire dans cette ère",
    "produced": "{value} / {target} produites dans cette ère",
    "keepsGems": "Tes gemmes restent",
    "keepsMilestones": "Tes jalons déjà obtenus restent",
    "keepsBonus": "Ton bonus permanent s’ajoute, il ne se remplace pas",
    "unlocks": "🎁 La prochaine ère débloque : {value}",
    "loses": "Tu perds ta ville, tes pièces et ton terrain — c’est le prix du bonus.",
    "action": "Nouvelle ère",
    "actionReady": "Nouvelle ère · +{value} de bonus",
    "confirm": "Recommencer ta ville ?",
    "confirmText": "Ta ville, tes pièces et ton terrain repartent de zéro. Tu gardes tes gemmes, tes jalons, et ton bonus passe à ×{value}.",
    "done": "Nouvelle ère ouverte !",
    "doneText": "Bonus permanent ×{value}",
    "history": "{eras} ère(s) traversée(s) · celle-ci dure depuis {age} · {total} pièces produites depuis toujours"
  },
  "tutorial": {
    "welcome": "Bienvenue chef ! Je suis Bricolo, ton contremaître. Je te fais visiter ?",
    "build": "Commençons : ouvre « Construire » et pose ta première maison — elle produit des pièces toute seule.",
    "land": "Ta ville va vite être à l'étroit. Dans « Ville », tu peux agrandir ton terrain.",
    "account": "Dans « Social », crée ton compte : ta ville aura une adresse à partager, et chaque visite te booste !",
    "ad": "Un coup de pouce gratuit ? Touche tes gemmes en haut, et regarde une pub : production ×2 pendant 1 h.",
    "done": "Tu sais tout, chef ! Je retourne au chantier — bonne construction 🏗️",
    "next": "Suivant",
    "later": "Plus tard",
    "skip": "Passer",
    "finish": "Merci Bricolo !"
  },
  "ads": {
    "offer": "Production ×{value} pendant {duration}, en regardant une publicité",
    "watch": "Regarder · {value} restante(s)",
    "exhausted": "Reviens demain !",
    "rewarded": "Merci d'avoir regardé !",
    "aborted": "Publicité interrompue — pas de récompense",
    "unavailable": "Aucune publicité disponible pour le moment — réessaie plus tard"
  },
  "traces": {
    "title": "Trace de visiteur",
    "text": "Un souvenir laissé par tes visiteurs. Vends-le, ou range-le où tu veux.",
    "sellFor": "Vendre · {value}",
    "move": "Déplacer",
    "moveHint": "Touche la case où la ranger",
    "sold": "Souvenir vendu !",
    "soldText": "+{value} pièces — merci à tes visiteurs",
    "rescued": "Décorations dégagées",
    "rescuedMoved": "{count} décoration(s) étaient sous une construction : elles ont été replacées.",
    "rescuedStashed": "{count} décoration(s) payée(s) sont retournées au sac, faute de place."
  },
  "advisor": {
    "quest": "Une quête est terminée — va chercher tes gemmes",
    "era": "Une nouvelle ère t'attend : ta ville repart, le bonus reste",
    "bag": "{count} décoration(s) payée(s) dorment dans ton sac",
    "roads": "{count} cases de rue ne servent plus — récupère ce terrain",
    "land": "Tu peux agrandir ton terrain maintenant",
    "build": "Tu as de quoi construire — pose un bâtiment",
    "unlock": "Encore {count} à poser pour ouvrir le bâtiment suivant",
    "share": "Montre ta ville : chaque visite la fait produire plus",
    "fold": "Réduire Bricolo",
    "unfold": "Déplier Bricolo"
  },
  "promo": {
    "title": "Mes autres jeux",
    "hint": "Du même créateur que Villopia — viens jeter un œil !",
    "play": "Découvrir",
    "tradopia": "Apprends la bourse en jouant — sans risquer un centime",
    "empty": "Aucun pour le moment — le prochain jeu arrivera ici.",
    "worldblocks": "Puzzle de blocs, construction de villes et défis entre amis"
  },
  "gems": {
    "title": "Utiliser tes gemmes",
    "rush": "Production ×{value} pendant {duration}",
    "rushBought": "Production accélérée !",
    "land": "Agrandir le terrain tout de suite",
    "landCost": "{value} 💎",
    "landBought": "Terrain agrandi !",
    "tooFew": "Pas assez de gemmes",
    "tooFewHint": "Les quêtes et les jalons en donnent.",
    "rushTitle": "Accélérer la production",
    "rushTier": "×{value} · {duration}",
    "rushTierCost": "×{value} · {duration}\n{cost} 💎",
    "skipTitle": "Avancer la production",
    "skipLeft": "Avancer la production · {value} restante(s) aujourd’hui",
    "skipExhausted": "Avance de production — reviens demain !",
    "skipTierCost": "{duration}\n{cost} 💎",
    "night": "Nuit blanche : le prochain retour compte 24 h, à moitié tarif",
    "nightCost": "{value} 💎",
    "nightReady": "En réserve",
    "reroll": "Changer les quêtes du jour",
    "rerollCost": "{value} 💎",
    "rerollDone": "Déjà changé aujourd’hui",
    "repairTitle": "Ta chaîne de {value} jours s’est rompue",
    "repairCost": "Rétablir · {value} 💎",
    "skipBought": "Avance encaissée !",
    "skipEmpty": "Pose un bâtiment d’abord : il n’y a rien à avancer.",
    "nightBought": "Nuit blanche en réserve !",
    "rerollBought": "Trois nouvelles quêtes !",
    "repairDone": "Rachat déjà utilisé cette semaine",
    "repairBought": "Chaîne rétablie !",
    "gift": "Cadeau de bienvenue",
    "giftText": "Production ×{value} pendant {duration}, offerte. Voilà ce que les gemmes achètent."
  },
  "visits": {
    "boostActive": "Production ×{value} grâce à tes visiteurs",
    "boostNone": "Partage ton lien : chaque visite booste ta production pendant 2 h",
    "received": "Nouveau visiteur ! Production boostée",
    "boostActiveFor": "Boost ×{value} — encore {time}"
  },
  "a11y": {
    "city": "Ta ville, vue de dessus"
  },
  "milestoneBook": {
    "title": "Livre des jalons",
    "summary": "{count} jalons encaissés sur {total} · {gems} gemmes gagnées",
    "family": "{done} obtenus sur {total} dans cette famille",
    "more": "+ {count} autres derrière, et la liste ne s’épuise pas",
    "done": {
      "first-building": "Chaque bâtiment du catalogue a vu le jour",
      "production": "La production n’a pas de sommet — continue",
      "land": "Tout le terrain est conquis",
      "roads": "Ton réseau a atteint sa pleine étendue",
      "decor": "Ta ville est décorée comme tu l'entendais",
      "eras": "Vingt et une ères — la ville n'a plus de secret",
      "visitors": "Les foules sont venues — et reviennent",
      "prestige": "Ta première ère est derrière toi"
    }
  },
  "league": {
    "title": "Ta division",
    "next": "Encore {value} pièces produites pour atteindre {name}",
    "soon": "Le classement entre joueurs ouvre bientôt — ta division, elle, monte déjà."
  },
  "ranking": {
    "title": "Classement mondial",
    "own": "Tu es {rank}e sur {total} villes classées",
    "percentile": "devant {value} % des villes",
    "era": "ère {value}",
    "perSecond": "{value} pièces produites",
    "reload": "Actualiser",
    "loading": "Lecture du classement…",
    "offline": "Classement indisponible hors ligne — ta ville continue de produire.",
    "pending": "Le classement se calcule côté serveur, plusieurs fois par jour. La première passe n’a pas encore tourné.",
    "unranked": "Ta ville n’est pas encore classée : pose ton premier bâtiment, la production suivante te fera entrer.",
    "unnamed": "Ta ville s’appelle encore « Ma ville » — renomme-la pour entrer au classement, et gagne {value} 💎"
  },
  "ludopia": {
    "title": "Compte Ludopia",
    "pitch": "Un pseudo, un avatar et des Ludos partagés entre tous les jeux Ludopia. Ta ville et ta sauvegarde ne changent pas.",
    "connect": "Se connecter avec Ludopia",
    "disconnect": "Se déconnecter de Ludopia",
    "purse": "{value} Ludos",
    "returnPending": "Échange en cours avec Ludopia…",
    "returnWelcome": "Bienvenue, {value} ! Retour au jeu…",
    "returnRefused": "Ludopia a refusé cette connexion. Reviens au jeu et réessaie.",
    "returnNoVerifier": "Lien incomplet : la connexion doit repartir depuis le jeu.",
    "returnMissing": "Aucun code de connexion dans ce lien."
  },
  "clearing": {
    "title": "Défricher",
    "confirm": "Défricher",
    "askTitle": "Défricher cette case pour {value} pièces ?",
    "done": "Défriché — {value} pièces",
    "regrowTitle": "Laisser la nature reprendre cette case ?",
    "regrown": "La nature est revenue",
    "tooExpensive": "Il te faut {value} pièces",
    "tooExpensiveHint": "Le prix monte à chaque défrichage — il repart de zéro à la prochaine ère."
  },
  "decor": {
    "bush": "Bosquet",
    "rock": "Rocher",
    "rockTall": "Grand rocher",
    "bin": "Poubelle",
    "tree": "Arbre",
    "treeRound": "Arbre rond",
    "treeTall": "Grand arbre",
    "potplants": "Plantes en pot",
    "flowerbed": "Jardinière",
    "bench": "Banc",
    "lamp": "Lampadaire",
    "fountain": "Fontaine"
  },
  "decorRefused": {
    "unknown": "Décoration inconnue",
    "no-room": "Ta ville est pleine — agrandis le terrain",
    "no-island": "Impossible pour l'instant",
    "too-few-gems": "Il te manque des gemmes"
  }
}
